import "./App.css";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Switch, Route, Redirect } from "react-router-dom";
import "react-lazy-load-image-component/src/effects/blur.css";

//components
import Claims from "./components/claims/Claims";
import Footer from "./components/footer/Footer";
import AboutUs from "./components/aboutUs/AboutUs";

import Faq from "./components/faq/Faq.jsx";


import BecomeAgent from "./components/becomeAgent/becomeAgent";

import Contact from "./components/contact/Contact.jsx";

import Careers from "./components/careers/Careers.jsx";


import RequestedHelp from "./components/contact/requestedHelp";
import Insurance from "./components/insurance/Insurance";
// import LeinHolder from "./components/leinHolder/leinHolder";
import LeinHolder from "./components/leinHolder/leinholder.jsx";
// import HomePage from "./components/homePage/homePage";
import NotFoundPage from "./components/404page/404page";
// import Accessibility from "./components/footer/accessibility/accessibility";
import Accessibility from "./components/footer/accessibility/AccessibilityStatement.jsx";
// import SiteRequirements from "./components/footer/siteRequirements/siteRequirements";
import SiteRequirements from "./components/footer/siteRequirements/SiteRequirements.jsx";
// import SiteMap from "./components/footer/siteMap/siteMap";
import SiteMap from "./components/footer/siteMap/SiteMapSection.jsx";
// import PrivacyPolicy from "./components/footer/privacyPolicy/privacyPolicy";
import PrivacyPolicy from "./components/footer/privacyPolicy/PrivacyPolicy.jsx";
import TermsOfUse from "./components/footer/termsofuse/TermsOfUse.jsx";
import NewUserCustomer from "./components/header/newUserCustomer";
import GetAQuote from "./components/getAQuote/getAQuote";
// import Header from "./components/header/Header";

import AgentLogin from "./components/header/agentsLogin.jsx";


import Home from "./components/homePage/Home";
// import Header from "./components/header/header_santosh";
import Header from "./components/header/Header";
import FindAnAgents from "./components/findAnAgent/FindAnAgents";

import PolicyHolderPortal from "./components/policyHolderPortal/policyHolderPortal.jsx";

function App() {
  const dispatch = useDispatch();

  const isMessageSuccess = useSelector((state) => state.messageSuccessReducer);
  const isMessageError = useSelector((state) => state.messageErrorReducer);
  const message = useSelector((state) => state.messageReducer);

  useEffect(() => {
    if (window.navigator.userAgent.indexOf("Trident") >= 0) {
      // window.location.href = "https://www.uaig.net/defaultIE.html";
    }
  }, []);

  // useEffect(() => {
  //   if (isMessageError === true) {
  //     setTimeout(() => {
  //       dispatch({
  //         type: "SET_ERROR_MESSAGE",
  //         payload: false,
  //       });
  //     }, 4000);
  //   } else if (isMessageSuccess === true) {
  //     setTimeout(() => {
  //       dispatch({
  //         type: "SET_SECCESS_MESSAGE",
  //         payload: false,
  //       });
  //     }, 4000);
  //   }
  // }, [isMessageSuccess, isMessageError]);

  const errorMessageComponent = () => {
    return (
      <div
        className={
          isMessageError
            ? "error-message-app-shown"
            : "error-message-app-hidden"
        }
      >
        <div></div>
        <h3 className="error-message-header">{message}</h3>
      </div>
    );
  };

  const messageComponent = () => {
    return (
      <div
        className={
          isMessageSuccess ? "message-app-shown" : "message-app-hidden"
        }
      >
        <div></div>
        <h3>{message}</h3>
      </div>
    );
  };

  return (
    <div className="App">
      {/* {errorMessageComponent()}
      {messageComponent()} */}
      <header>
        <Header />
      </header>
      <main>
        <>
          {/* <SEO_Header /> */}
          {/* <Home/> */}
          <Switch>
            <Redirect
              exact
              from="/"
              to="/uaichome"
              component={Home}
            ></Redirect>
            
            <Route exact path="/uaichome" component={Home} />
            <Route exact path="/uaichome/agent" component={AgentLogin} />
            <Route exact path="/uaichome/aboutus" component={AboutUs} />
            <Route exact path="/uaichome/becomeagent" component={FindAnAgents} />
            <Route exact path="/uaichome/policyholder" component={PolicyHolderPortal} />
            <Route exact path="/uaichome/claims" component={Claims} />
            <Route exact path="/uaichome/claims/faq" component={Faq} />
            <Route exact path="/uaichome/careers" component={Careers} />
            <Route exact path="/uaichome/contact" component={Contact} />
            <Route exact path="/uaichome/FindAnAgent" component={FindAnAgents} />
            <Route
              exact
              path="/uaichome/requestedhelp"
              component={RequestedHelp}
            />
            <Route exact path="/uaichome/insurance" component={Insurance} />
            <Route exact path="/uaichome/leinholder" component={LeinHolder} />
            <Route exact path="/uaichome/site-map" component={SiteMap} />
            <Route
              exact
              path="/uaichome/site-requirements"
              component={SiteRequirements}
            />
            <Route
              exact
              path="/uaichome/accessibility"
              component={Accessibility}
            />
            <Route
              exact
              path="/uaichome/privacy-policy"
              component={PrivacyPolicy}
            />
            <Route
              exact
              path="/uaichome/terms-of-use"
              component={TermsOfUse}
            />
            <Route
              exact
              path="/uaichome/newuser/customer"
              component={NewUserCustomer}
            />
            <Route exact path="/uaichome/getaquote" component={GetAQuote} />
            <Route render={() => <Redirect to="/uaichome" />}>
              <NotFoundPage />
            </Route>
          </Switch>
        </>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default App;
